<div class="w-full text-center h-full pt-16">
  <ng-container [ngTemplateOutlet]="successIcon"></ng-container>
  <ng-container [ngTemplateOutlet]="welcomeMessage"></ng-container>
</div>

<!-- Success Icon Template -->
<ng-template #successIcon>
  <div class="mb-6 animate-bounce" role="img" aria-label="Ícono de éxito">
    <div
      class="w-20 h-20 bg-allasRed rounded-full flex items-center justify-center shadow-lg animate-pulse mx-auto"
    >
      <svg
        class="w-12 h-12 text-white animate-ping"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
          d="M5 13l4 4L19 7"
        ></path>
      </svg>
    </div>
  </div>
</ng-template>

<!-- Welcome Message Template -->
<ng-template #welcomeMessage>
  <section
    class="text-center animate-fade-in mb-8"
    role="main"
    aria-labelledby="welcome-title"
  >
    <h1
      id="welcome-title"
      class="text-2xl md:text-3xl font-bold text-gray-900 mb-4 animate-slide-up"
    >
      ¡Gracias por iniciar sesión!
    </h1>
    <p class="text-blue-500 text-lg animate-slide-up-delayed">
      Bienvenido a Allas Repuestos
    </p>
  </section>
</ng-template>
